export const CONTACT_API_PATHS = {
  SEND_MESSAGE: "/contact",
} as const
